<template>
  <v-card class="auth-form elevation-12">
    <v-toolbar dark color="primary">
      <v-toolbar-title v-if="!isAuth">Login form</v-toolbar-title>
      <v-toolbar-title v-if="isAuth">Hello {{ activeUser.displayName || activeUser.email }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon
        v-if="isAuth"
        @click="logOut"
      >
        Logout
      </v-toolbar-side-icon>
      <!-- <v-btn
        color="primary"
      >Logout</v-btn> -->
    </v-toolbar>
    <v-card-text v-if="!isAuth">
      <v-form>
        <v-text-field
          prepend-icon="person"
          name="username"
          label="Username"
          type="text"
          v-model="username"
        ></v-text-field>
        <v-text-field
          id="password"
          prepend-icon="lock"
          name="password"
          label="Password"
          type="password"
          v-model="password"
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions v-if="!isAuth">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="emailLogin">Login</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss">
.auth-form {
  display: inherit;
}
</style>

<script>
import { auth } from '@/db.js'

export default {
  name: 'authForm',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  computed: {
    isAuth () {
      return this.$store.state.isAuth
    },
    activeUser () {
      return this.$store.state.activeUser
    }
  },
  methods: {
    logOut: function () {
      auth.logOut().then(() => {
        this.$store.dispatch('authLogOut')
      })
    },
    emailLogin: function () {
      auth
        .emailLogIn(
          this.username,
          this.password
        )
        .then(
          user => {
            // Store result in vuex
            this.$store.dispatch('authLogIn', auth.currentUser())

            this.$router.push('/admin')

            // reset
            this.username = ''
            this.password = ''
          },
          err => {
            alert(err.message)
          }
        )
    }
  }
}
</script>
